import * as React from "react";
import { forwardRef } from "react";
const SvgHinzufuegen15PxWeiss = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14.42, height: 15, viewBox: "0 0 14.42 15", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Pfad_724", "data-name": "Pfad 724", d: "M491.426,356.678h-5.71v-6a.75.75,0,0,0-1.5,0v6h-5.71a.75.75,0,0,0,0,1.5h5.71v6a.75.75,0,0,0,1.5,0v-6h5.71a.75.75,0,0,0,0-1.5Z", transform: "translate(-477.756 -349.928)", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgHinzufuegen15PxWeiss);
export { ForwardRef as ReactComponent };
